import React,{useEffect,useRef,useState} from 'react'
import {useAuth} from '../contexts/AuthContext'
import {useNavigate} from 'react-router-dom'
import {domusApi} from '../services/domusApi'
import toast from 'react-hot-toast'
const GOOGLE_CLIENT_ID=import.meta.env.VITE_GOOGLE_CLIENT_ID
export default function GoogleSignIn(){
 const ref=useRef(null)
 const {signInWithGoogle}=useAuth()
 const navigate=useNavigate()
 const [error,setError]=useState('')
 useEffect(()=>{
  if(!GOOGLE_CLIENT_ID)return
  let mounted=true
  const setup=()=>{
   if(!mounted||!ref.current||!window.google?.accounts?.id)return
   window.google.accounts.id.initialize({
    client_id:GOOGLE_CLIENT_ID,
    callback:async response=>{
     try{
      if(!response?.credential)throw Error('Credencial Google não recebida')
      await signInWithGoogle(response.credential)
      const families=await domusApi.families()
      navigate(families.data?.length?'/dashboard':'/family-setup')
     }catch(e){toast.error(e.message||'Não foi possível autenticar com Google')}
    }
   })
   ref.current.replaceChildren()
   window.google.accounts.id.renderButton(ref.current,{theme:'outline',size:'large',text:'continue_with',width:320,locale:'pt-PT'})
  }
  if(window.google?.accounts?.id){setup()}
  else{
   const script=document.createElement('script')
   script.src='https://accounts.google.com/gsi/client'
   script.async=true
   script.defer=true
   script.onload=setup
   script.onerror=()=>{if(mounted)setError('Não foi possível carregar a autenticação Google')}
   document.head.appendChild(script)
  }
  return()=>{mounted=false}
 },[navigate,signInWithGoogle])
 if(!GOOGLE_CLIENT_ID)return <p className="text-sm text-amber-700 text-center">Entrar com Google: aguarda configuração do ID OAuth no Coolify.</p>
 return <div className="flex flex-col items-center"><div ref={ref}/>{error&&<p role="alert" className="text-red-700 text-sm">{error}</p>}</div>
}
